// src/components/EmptyRankingSlot.tsx
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface EmptyRankingSlotProps {
  id: string;  // Sortable ID
  index: number;
  onAddToSlot: () => void;
}

export function EmptyRankingSlot({ id, index, onAddToSlot }: EmptyRankingSlotProps) {
  const { 
    attributes, 
    listeners, 
    setNodeRef, 
    transform, 
    transition,
    isDragging
  } = useSortable({ id });
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : 1,
  };
  
  return (
    <div ref={setNodeRef} style={style} className="mb-3">
      <div className={`flex items-center bg-white rounded-lg py-3 px-3 shadow-sm border border-dashed ${
        isDragging ? 'border-pink-500 bg-pink-50' : 'border-gray-300 hover:border-gray-400'
      }`}>
        {/* Ranking number */}
        <div 
          className="flex-shrink-0 w-8 h-8 flex items-center justify-center font-bold text-lg text-gray-400"
          {...attributes} 
          {...listeners}
        >
          {index + 1}
        </div>
        
        {/* Empty placeholder with call-to-action */}
        <div className="flex-grow flex flex-col items-center justify-center py-3">
          <button
            onClick={onAddToSlot}
            className="flex flex-col items-center text-gray-500 hover:text-pink-500"
          >
            <span className="mt-2 text-sm items-center font-medium flex border rounded-full align-items p-2 px-4">
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add to this position</span>
          </button>
        </div>
      </div>
    </div>
  );
}